import { apiClient } from './client';

export function getUsers (shopId: number | string) {
  return apiClient.get(`/${shopId}/user-management`);
}

export function createUser (shopId: number | string, userData: Record<string, unknown>) {
  return apiClient.post(`/${shopId}/user-management`, userData);
}

export function updateUser (shopId: number | string, userId: number | string, userData: Record<string, unknown>) {
  return apiClient.put(`/${shopId}/user-management/${userId}`, userData);
}

export function deleteUser (shopId: number | string, userId: number | string) {
  return apiClient.delete(`/${shopId}/user-management/${userId}`);
}

export function restoreUser (shopId: number | string, userId: number | string) {
  return apiClient.post(`/${shopId}/user-management/${userId}/restore`);
}

export function resendInvite (shopId: number | string, userId: number | string) {
  return apiClient.post(`/${shopId}/user-management/${userId}/resend-invite`);
}

export function changeAccountOwner (shopId: number | string, payload: Record<string, unknown>) {
  return apiClient.post(`/${shopId}/user-management/change-account-owner`, payload);
}

export function updateUserStatus (shopId: number | string, userId: number | string, status: string) {
  return apiClient.patch(`/${shopId}/user-management/${userId}/status`, { status });
}
